<nz-modal
  [(nzVisible)]="visible"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzWrapClassName]="'share-watchlist-modal'"
  (nzOnCancel)="closeModal()"
>
<ng-container *nzModalContent >
  <div class="header">
    <span class="title">Share Watchlist</span>
    <va-icon isFontAwesome="true" class="icon" (click)="closeModal()" [name]="faCloseIcon"></va-icon>
  </div>

  <div class="content">
    <ng-template #prefixSearchIcon>
      <va-icon size="small" class="icon" name="search"></va-icon>
    </ng-template>

    <nz-input-group class="email-input" [nzPrefix]="prefixSearchIcon">
      <input
        #emailInputBox
        [formControl]="emailInput"
        nz-input
        type="text"
        spellcheck="false"
        placeholder="Search name or email"
        [nzAutocomplete]="auto"
      />

      <nz-autocomplete
        nzBackfill
        [nzOverlayClassName]="'suggestion-dropdown'"
        #auto
      >
        <nz-auto-option
          *ngFor="let suggestion of userSuggestions"
          (click)="onSuggestionSelected()"
          [nzValue]="suggestion.email"
        >
          {{ suggestion.full_name }} ({{ suggestion.email }})
        </nz-auto-option>
        <nz-auto-option
          *ngIf="
            userSuggestions.length === 0 &&
            emailInput.value !== null &&
            emailInput.value.length > 0 &&
            allowUserSuggestionError
          "
          class="not-found"
        >
          <va-icon isFontAwesome="true" class="icon" [name]="faExclamationCircle"></va-icon>
          No name or email matches the input
        </nz-auto-option>
      </nz-autocomplete>
    </nz-input-group>

    <button
      class="share-btn"
      [class.disable]="disableShareBtn"
      (click)="shareWatchlist(emailInputBox)"
      nz-button
      nzType="primary"
    >
      Share
    </button>

    <ng-template #noData>
      <span class="no-data">
        You haven't shared this Watchlist to anyone, Please search and share.
      </span>
    </ng-template>

    <nz-table
      #sharedTable
      *ngIf="sharedList"
      [nzData]="sharedList"
      [nzScroll]="{ y: '224px' }"
      [nzShowPagination]="false"
      [nzPageSize]="sharedList.length"
      [nzNoResult]="noData"
      class="share-watchlist-table"
    >
      <thead>
        <tr>
          <th
            nzWidth="180px"
            [nzSortFn]="undefined"
            [nzShowSort]="true"
            (nzSortOrderChange)="onSortChange($event, 'recipient')"
          >
            Recipient
          </th>
          <th
            [nzSortFn]="undefined"
            [nzShowSort]="true"
            (nzSortOrderChange)="onSortChange($event, 'email')">
            Email
          </th>
          <th
            nzWidth="100px"
            [nzSortFn]="undefined"
            [nzShowSort]="true"
            (nzSortOrderChange)="onSortChange($event, 'date')"
          >
            Date
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of sharedTable.data">
          <td>{{ item.recipient }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.date }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
</nz-modal>
